/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Skeleton, SkeletonRow, Card } from '@adobe-commerce/elsie/components';
import '@/account/components/AccountLoaders/AccountLoaders.css';
import { classes } from '@adobe-commerce/elsie/lib';

export const CardLoader = ({
  testId,
  withCard = true,
}: {
  testId?: string;
  withCard?: boolean;
}) => {
  const defaultSkeleton = (
    <Skeleton data-testid={testId || 'skeletonLoader'}>
      <SkeletonRow
        variant="heading"
        size="xlarge"
        fullWidth={false}
        lines={1}
      />
      <SkeletonRow variant="heading" size="xlarge" fullWidth={true} lines={1} />
      <SkeletonRow variant="heading" size="xlarge" fullWidth={true} lines={1} />
    </Skeleton>
  );

  if (withCard) {
    return defaultSkeleton;
  }

  return (
    <Card
      variant="secondary"
      className={classes([
        'account-account-loaders',
        'account-account-loaders--card-loader',
      ])}
    >
      {defaultSkeleton}
    </Card>
  );
};

export const AddressFormLoader = () => {
  return (
    <Skeleton data-testid="addressFormLoader">
      <SkeletonRow variant="heading" size="medium" />
      <SkeletonRow variant="empty" size="medium" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" fullWidth={true} />
      <SkeletonRow size="large" fullWidth={true} lines={3} />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" />
      <SkeletonRow size="large" fullWidth={true} />
    </Skeleton>
  );
};

export const PickerLoader = (props: any) => {
  return (
    <Skeleton
      {...props}
      rowGap={'xsmall'}
      className={classes([
        'account-account-loaders',
        'account-account-loaders--picker-loader',
      ])}
    >
      <SkeletonRow variant="heading" size="xsmall" />
      <SkeletonRow variant="empty" size="small" />
      <SkeletonRow size="small" />
    </Skeleton>
  );
};
